"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameColorLetter = exports.GameColor = void 0;
var GameColor;
(function (GameColor) {
    GameColor["Blue"] = "blue";
    GameColor["Red"] = "red";
    GameColor["Yellow"] = "yellow";
    GameColor["Green"] = "green";
    GameColor["None"] = "none";
})(GameColor || (exports.GameColor = GameColor = {}));
exports.GameColorLetter = {
    R: GameColor.Red,
    G: GameColor.Green,
    B: GameColor.Blue,
    Y: GameColor.Yellow,
    N: GameColor.None,
};
